// SPDX-License-Identifier: BUSL-1.1

/**
 * Title row for the agent-detail page — name, status pill, model, sdk badge,
 * and the terminate-sessions action.
 *
 * Extracted from `routes/agent-detail.tsx` during the P3b refactor.
 */

import { AGENT_STATUS_COLORS } from '@/types/api';
import { TerminateDialog } from './terminate-dialog';

export function AgentDetailHeader({
  displayName,
  displayStatus,
  displayModel,
  displaySdk,
  showSessions,
  onTerminate,
  terminatePending,
}: {
  displayName: string;
  displayStatus: keyof typeof AGENT_STATUS_COLORS | string;
  displayModel?: string | null;
  displaySdk?: string | null;
  showSessions: boolean;
  onTerminate: () => void;
  terminatePending: boolean;
}) {
  const statusColors =
    AGENT_STATUS_COLORS[displayStatus as keyof typeof AGENT_STATUS_COLORS] ??
    AGENT_STATUS_COLORS.offline;

  return (
    <div className="mb-6 flex items-center justify-between">
      <div>
        <h1 className="text-2xl font-bold text-neutral-100">
          {displayName}
        </h1>
        <div className="mt-2 flex items-center gap-3">
          <span
            className={`inline-flex rounded px-2 py-0.5 text-xs ${statusColors}`}
          >
            {displayStatus}
          </span>
          {displayModel && (
            <span className="text-sm text-neutral-400">
              {displayModel}
            </span>
          )}
          {displaySdk && (
            <span className="inline-flex rounded bg-purple-900/50 px-2 py-0.5 text-xs text-purple-300">
              {displaySdk}
            </span>
          )}
        </div>
      </div>
      <div className="flex items-center gap-2">
        {showSessions && (
          <TerminateDialog
            agentName={displayName}
            onConfirm={onTerminate}
            isPending={terminatePending}
          />
        )}
      </div>
    </div>
  );
}
